import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

const ObservacoesPedidoContainer = styled.div<{ theme: ThemeType }>`
  width: 90%;
  padding: 2rem 0;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;  
    margin-bottom: 2rem;

    @media (max-width: 768px) {
      flex-direction: row !important;
      align-items: center !important;
    }

    @media (max-width: 425px) {
      flex-direction: column !important;
      align-items: start !important;
      gap: 2rem !important;
    }


    .titulo {
      color: ${({ theme }) => theme.colors.tertiary};
      font-weight: normal;
    }
  }

  .sem-observacoes {
    color: ${({ theme }) => theme.colors.tertiary};
    opacity: 0.6;
    text-align: center;
    padding: 2rem;
  }

  .lista-observacoes {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .observacao-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 2.5rem;
    background-color: ${({ theme }) => theme.colors.background2};
    border-radius: 12px;
    gap: 5rem;

    .observacao-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 1.8rem;

    .linha-menor {
      width: 100%;
      height: 2px;
      border-radius: 50px;
      background-color: ${(props) => props.theme.colors.elements};
    }
    .info {
      font-weight: bold;
    }

      .observacao-texto {
        color: ${({ theme }) => theme.colors.tertiary};
        word-break: break-word;
        text-align: justify;
      }

      .observacao-info {
        display: flex;
        align-items: baseline;
        gap: 1rem;
        flex-wrap: wrap;
        color: ${({ theme }) => theme.colors.tertiary};


        .data {
          color: ${({ theme }) => theme.colors.tertiary};
          opacity: 0.6;
        }
      }
    }

    .observacao-acoes {
      display: flex;
      gap: 1.5rem;
      align-items: center;

      span {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.primary};
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.7;
        }
      }

      .remover {
        color: #d32f2f;
      }
    }
  }

  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      gap: 1rem;
      align-items: flex-start;
    }

    .observacao-item {
      flex-direction: column;

      .observacao-acoes {
        align-self: flex-end;
      }
    }
  }
`;

const ModalContainer = styled.div<{ theme: ThemeType }>`
  padding: 3rem;

  .form-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .toggle-container {
    display: flex;
    align-items: center;
    padding: 1rem 0rem;
    gap: 1.5rem;

    .toggle-label {
      color: ${({ theme }) => theme.colors.tertiary};
      font-size: 1.4rem;
    }
  }

  .aviso-visivel {
    background-color: #e8f5e9;
    color: #2e7d32;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    font-size: 1.3rem;
  }

  .botoes {
    display: flex;
    justify-content: space-between;
    padding: 0 3rem;
    align-items: center;
    margin-top: 3rem;

    .cancelar {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.tertiary};

      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export { ObservacoesPedidoContainer, ModalContainer };
